import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../config/supabase';
import apiService from '../../services/api.service';
import './Onboarding.css';

const Onboarding = () => {
    const [orgName, setOrgName] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [user, setUser] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Listen for auth state changes
        const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
            console.log('Auth state change:', event, session?.user?.email);
            if (session?.user) {
                setUser(session.user);
            } else if (event === 'SIGNED_OUT') {
                navigate('/login');
            }
        });

        // Initial check
        const checkUser = async () => {
            const { data: { user } } = await supabase.auth.getUser();
            if (user) {
                setUser(user);
            } else {
                // Wait a bit for the session to be picked up from the URL hash
                setTimeout(async () => {
                    const { data: { user: retryUser } } = await supabase.auth.getUser();
                    if (!retryUser) {
                        navigate('/login');
                    } else {
                        setUser(retryUser);
                    }
                }, 1500);
            }
        };
        checkUser();

        return () => subscription.unsubscribe();
    }, [navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const response = await apiService.post('/organizations/onboard', {
                name: orgName,
                supabaseUid: user.id,
                email: user.email
            });

            if (response.success) {
                // Set legacy auth flag for compatibility
                localStorage.setItem('isAuthenticated', 'true');
                localStorage.setItem('username', user.email);

                // Successfully onboarded, redirect to dashboard
                navigate('/dashboard');
            } else {
                setError(response.message || 'Failed to complete onboarding');
            }
        } catch (err) {
            setError(err.message || 'An error occurred during onboarding');
        } finally {
            setLoading(false);
        }
    };

    if (!user) return <div className="onboarding-loading">Verifying session...</div>;

    return (
        <div className="onboarding-container">
            <div className="onboarding-card">
                <div className="onboarding-header">
                    <h1>Welcome to TITAN</h1>
                    <p>Let's set up your organization to get started.</p>
                </div>

                <form className="onboarding-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="orgName">Organization Name</label>
                        <input
                            type="text"
                            id="orgName"
                            value={orgName}
                            onChange={(e) => setOrgName(e.target.value)}
                            placeholder="e.g. Acme Logistics"
                            required
                        />
                    </div>

                    <div className="user-preview">
                        <label>Account</label>
                        <div className="preview-value">{user.email}</div>
                    </div>

                    <button type="submit" className="onboarding-btn" disabled={loading || !orgName}>
                        {loading ? 'Setting up...' : 'Complete Setup'}
                    </button>
                </form>

                {error && <div className="onboarding-error">{error}</div>}
            </div>
        </div>
    );
};

export default Onboarding;
